export const DEFAULT_CURRENCY = "GBP";

export const CURRENCY_CATALOG = {
  GBP: { code: "GBP", symbol: "£", name: "British Pound", locale: "en-GB" },
  EUR: { code: "EUR", symbol: "€", name: "Euro", locale: "en-IE" },
  USD: { code: "USD", symbol: "$", name: "US Dollar", locale: "en-US" },
};

export const CURRENCY_OPTIONS = Object.values(CURRENCY_CATALOG);

export function normalizeCurrency(code) {
  const upper = String(code || DEFAULT_CURRENCY).toUpperCase();
  return CURRENCY_CATALOG[upper] ? upper : DEFAULT_CURRENCY;
}

export function getCurrencyMeta(code) {
  return CURRENCY_CATALOG[normalizeCurrency(code)];
}

export function getCurrencySymbol(code) {
  return getCurrencyMeta(code).symbol;
}

export function formatMoney(amount, currencyCode = DEFAULT_CURRENCY) {
  const value = Number(amount || 0);
  return `${getCurrencySymbol(currencyCode)}${value.toFixed(2)}`;
}

export function formatMoneyWhole(amount, currencyCode = DEFAULT_CURRENCY) {
  const value = Number(amount || 0);
  return `${getCurrencySymbol(currencyCode)}${Math.round(value)}`;
}

/** Match common price prefixes when parsing pasted menu text. */
export function pricePrefixPattern() {
  return "(?:£|€|\\$|GBP|EUR|USD)\\s?";
}

const EUR_COUNTRIES = new Set([
  "ireland", "germany", "france", "spain", "italy", "netherlands", "belgium", "portugal",
  "austria", "greece", "finland", "luxembourg", "malta", "cyprus", "slovakia", "slovenia",
  "estonia", "latvia", "lithuania", "croatia", "eurozone",
]);

export function suggestCurrencyForCountry(country) {
  const normalized = String(country || "").trim().toLowerCase();
  if (!normalized) return DEFAULT_CURRENCY;
  if (EUR_COUNTRIES.has(normalized) || normalized.includes("euro")) return "EUR";
  if (normalized.includes("united states") || normalized === "usa" || normalized === "us") return "USD";
  if (normalized.includes("united kingdom") || normalized === "uk" || normalized === "gb" || normalized.includes("england") || normalized.includes("scotland") || normalized.includes("wales")) {
    return "GBP";
  }
  return DEFAULT_CURRENCY;
}
